import { Box, Divider, ListItem, ListItemButton } from "@mui/material";
import React, { useCallback, useLayoutEffect, useRef, useState } from "react";

import ImageQueryThumbnail from "components/common/ImageQueryThumbnail";
import { QueryDetailsModalActions, SET_IMAGE_QUERY } from "reducers/QueryDetailsModalReducer";
import { ImageQuery } from "types/imageQueries";

export interface QueryDetailsPreviewProps {
  rowData: ImageQuery;
  setSelectedRow: (arg0: ImageQuery) => void;
  selectedId: string;
  setIsDeleteModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  dispatch: React.Dispatch<QueryDetailsModalActions>;
  lastItem: boolean;
}

export const QueryDetailsPreview = React.memo((props: QueryDetailsPreviewProps) => {
  const { selectedId, setSelectedRow, rowData: data, setIsDeleteModalOpen, dispatch: localDispatch, lastItem } = props;
  const [shouldAutoScroll, setShouldAutoScroll] = useState(true);

  const ref = useRef<HTMLDivElement>(null);
  const selected = data?.iq_id === selectedId;

  // This useffect is in charge of scrolling to the corresponding selected row
  useLayoutEffect(() => {
    if (selected && ref.current && shouldAutoScroll) {
      setTimeout(() => {
        ref.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);

  const onSetSelectedRow = () => {
    setShouldAutoScroll(false);
    setSelectedRow(data);
    setTimeout(() => setShouldAutoScroll(true), 400);
  };

  const onOpenDeleteModal = useCallback(
    (imageQuery: ImageQuery) => {
      localDispatch({ type: SET_IMAGE_QUERY, payload: imageQuery });
      setSelectedRow(data);
      setIsDeleteModalOpen(true);
    },
    [data, localDispatch, setIsDeleteModalOpen, setSelectedRow]
  );

  return (
    <Box ref={ref}>
      <ListItem
        style={{
          width: "100%",
          padding: 0,
          backgroundColor: selected ? "#CCEAFF" : undefined,
        }}
      >
        <ListItemButton style={{ padding: 0 }} onClick={onSetSelectedRow} selected={selected}>
          <ImageQueryThumbnail
            isQueryDetailsModal
            selected={data?.iq_id === selectedId}
            setIsDeleteModalOpen={onOpenDeleteModal}
            detectorData={data}
          />
        </ListItemButton>
      </ListItem>
      {!lastItem && (
        <Divider style={{ margin: 0 }} variant="middle" />
      )}
    </Box>
  );
});
